import type { FC } from 'react';
import { IconButton, Snackbar, ThemeProvider } from '@mui/material';

import { SNACKBAR_AUTOHIDE_DURATION } from '@mopla/constants';
import { passengerThemeV2 } from '@mopla/mui';
import { useBreakpoints } from '@mopla/utils';

import { CrossIcon } from '../../icons/Cross';

export interface IMplSnackbarProps {
	open: boolean;
	message: string;
	onClose: VoidFunction;
	autoHideDuration?: number;
	dismissible?: boolean;
	dataTestId?: string;
}

export const MplSnackbar: FC<IMplSnackbarProps> = ({
	open,
	message,
	onClose,
	autoHideDuration = SNACKBAR_AUTOHIDE_DURATION,
	dismissible = false,
	dataTestId = 'MplSnackbar',
}) => {
	const { isAboveMobile } = useBreakpoints();

	return (
		<ThemeProvider theme={passengerThemeV2}>
			<Snackbar
				open={open}
				message={message}
				autoHideDuration={autoHideDuration}
				onClose={onClose}
				ClickAwayListenerProps={
					dismissible ? undefined : { onClickAway: () => null }
				}
				anchorOrigin={
					isAboveMobile
						? { vertical: 'top', horizontal: 'right' }
						: { vertical: 'top', horizontal: 'center' }
				}
				sx={{
					top: isAboveMobile ? '24px !important' : '95px !important',
					left: isAboveMobile ? 'auto !important' : '16px !important',
					right: isAboveMobile ? '24px !important' : '16px !important',
					'& .MuiSnackbarContent-root': {
						backgroundColor: (theme) => theme.palette?.solutions?.[100],
						color: (theme) => theme.palette?.text?.primary,
						width: isAboveMobile ? 'auto' : '100%',
						maxWidth: isAboveMobile ? '400px' : 'none',
						minWidth: isAboveMobile ? '300px' : 'auto',
						borderRadius: (theme) => theme.shape.borderRadius,
						alignItems: 'center',
						flexWrap: 'nowrap',
					},
				}}
				action={
					<IconButton
						size="small"
						aria-label="close"
						color="inherit"
						onClick={onClose}
					>
						<CrossIcon fontSize="small" />
					</IconButton>
				}
				data-testid={dataTestId}
			/>
		</ThemeProvider>
	);
};
